import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=a5519f26&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=a5519f26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5519f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5519f26')) {
      api.createRecord('a5519f26', component.options)
    } else {
      api.reload('a5519f26', component.options)
    }
    module.hot.accept("./tableItem.vue?vue&type=template&id=a5519f26&scoped=true", function () {
      api.rerender('a5519f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/components/tableItem.vue"
export default component.exports